'use strict';

bbw.directive.bbwUrl = ['$rootScope', function($rootScope) {
    return {
        compile: function(_, attrs) {
            if (angular.isUndefined($rootScope.bbwUrls)) {
                $rootScope.bbwUrls = {};
            }
            var urls = attrs.bbwUrl;
            if (urls && angular.isString(urls)) {
                urls.trim().split(/\s*;\s*/).forEach(function(url) {
                    var tokens = url.trim().split(':');
                    if (tokens.length > 1) {
                        $rootScope.bbwUrls[tokens[0]] = tokens.slice(1).join(':');
                    }
                });
            }
        },
        link: angular.noop
    }
}];
